import { ApiMethod, type RequestInit } from "@/stores/types/api.types";
import { ensureAuthenticated } from "@haskoning/msal";
import { loginRequest, msalInstance } from "@/msalAuthConfig";
import { InteractionType } from "@azure/msal-browser";

function initializeRequest(
  url: string,
  method: ApiMethod,
  requestData?: any
): {
  url: string | URL;
  requestInit: RequestInit;
} {
  const requestInit: RequestInit = {
    method: method,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("access")}`,
    },
  };

  if (!url.includes("localhost")) {
    requestInit.credentials = "include";
  }

  if (method === ApiMethod.GET && requestData) {
    const urlObj = new URL(url);
    urlObj.search = new URLSearchParams(requestData).toString();
    return { url: urlObj, requestInit };
  } else if (method === ApiMethod.POST || method === ApiMethod.PUT) {
    requestInit.body = JSON.stringify(requestData);
  }

  return { url, requestInit };
}

async function handleResponse(response: Response): Promise<any> {
  if (!response.ok) {
    const errorMessage = await response.json();

    if (errorMessage.detail && Array.isArray(errorMessage.detail) && errorMessage.detail.length > 0) {
      const fullMessage = errorMessage.detail
        .map((detail: any) => `${detail.loc?.slice(1).join(".") ?? ""}: ${detail.msg}`)
        .join(";\n");
      throw new Error(fullMessage);
    }

    throw new Error(`API error: ${response.status} ${response.statusText}`);
  }

  return await response.json();
}

export async function callApi(url: string, requestItem?: any, method: ApiMethod = ApiMethod.GET): Promise<any> {
  const { url: updatedUrl, requestInit } = initializeRequest(url, method, requestItem);

  try {
    console.log("API Request:", updatedUrl, requestInit);
    const response = await fetch(updatedUrl.toString(), requestInit);

    if (response.status === 401) {
      if (await ensureAuthenticated(msalInstance, InteractionType.Popup, loginRequest)) {
        return await callApi(url, requestItem, method);
      }
    }

    return await handleResponse(response);
  } catch (error: any) {
    console.error("API Error:", error);
    throw new Error(error.message || "API call failed");
  }
}
